export default String.raw`
.authenticated-only {
  text-align: center !important;
  @include subtitle-medium;
}

.login-container {
  max-width: 100%;
  width: fit-content;
  box-sizing: border-box;
  margin: 24px auto 236px auto;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
  background-color: $bgColor;
  color: $primaryColorFont;
  .form__input-wrapper {
    display: inline-block;
    position: relative;
    background-color: inherit;
    margin-bottom: 23px;

    & + .form__input-wrapper {
      margin-bottom: 0;
    }
  }
  .form__icons:not(.form__preview) {
    color: $primaryColorFont;
    position: absolute;
    transform: translateY(-50%);
    top: 20px;
    left: -30px;
  }
  .form__icons.form__preview svg {
    fill: $labelsColor;
  }
  .form select {
    border-bottom: 1px solid $primaryColorFont;
  }

  .primary-action-button {
    width: 100%;
  }
}
.login-form {
  &__signIn {
    color: $primaryColorFont;
    text-align: left;
    line-height: 32px;
    font-weight: 500;
    font-size: 24px;
    display: block;
    margin-bottom: 24px;
  }
  &__welcomeMsg {
    margin: 0.6rem 0 4rem 0;
    color: $primaryColorFont;
    opacity: 0.65;
    text-align: center;
  }

  &__more-options {
    margin: 16px 0 24px;
    display: block;
  }
  &__registerLink {
    display: block;
    margin-top: 24px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
  &__forget-password {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $iconColors;
    text-decoration: none;
  }
  &__register {
    color: $iconColors;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    margin-left: 8px;
  }
  &__submit {
    margin: 0 auto 2.5rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0.8rem 0;
    display: block;
    height: auto;
  }
}

.login-container,
.login-container-popup {
  .login-form__socialButtons {
    display: block;
    width: 100%;
    font-size: 14px;
    color: $primaryColorFont;
    text-align: center;

    .login-form__socialButtons__buttons {
      display: flex;
      flex-direction: column;
      padding: 0 9px 0;

      .Facebook_Login_Container {
        display: flex;
        justify-content: center;
        align-items: center;

        .button__Social__facebook {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #dadce0;
          width: 250px;
          min-width: 250px;
          height: 40px;
          margin-top: 16px;
          cursor: pointer;
          background-color: #fff;
          color: #3c4043;
          margin-left: 1px;
          border-radius: 4px;
          font-weight: 425;
          font-size: 14px;
          letter-spacing: 0.25px;
        }
        .button__Social__facebook:hover {
          background-color: #f9faff;
          border: 1px solid #dbe1ee;
        }
      }

      .button__Social__google {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        cursor: pointer;
        background-color: inherit;
        font-size: 24px !important;
      }
    }

    .login-form__socialButtons__title {
      width: 100%;
      height: 12px;
      border-bottom: 1px solid $lightBorderColor;
      text-align: center;
      margin: 16px 0 0;
      .text {
        margin-bottom: 20px;
        padding: 0 8px;
        background-color: $bgColor !important;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .GFbLoginIcon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .FBIcon {
      width: 24px;
      height: 24px;
    }
  }

  .primary-action-button {
    width: 100%;
  }
}

.login-container-popup {
  position: relative;
  max-width: 100%;
  width: 444px;
  box-sizing: border-box;
  margin: 24px auto 236px auto;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
  background-color: $bgColor;
  color: $primaryColorFont;
  top: 50%;
  transform: translateY(-50%);
  left: 0px;
  right: 0px;

  .login-form {
    &__signIn {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
`